import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'month'
})
export class MonthPipe implements PipeTransform {

  transform(value: any): string {
    let monthStr;
    switch(value) {
      case 0:
        monthStr = 'Jan'
        break;
      case 1:
        monthStr = 'Feb'
        break;
      case 2:
        monthStr = 'Mar'
        break;
      case 3:
        monthStr = 'Apr'
        break;
      case 4:
        monthStr = 'May'
        break;
      case 5:
        monthStr = 'Jun'
        break;
      case 6:
        monthStr = 'Jul'
        break;
      case 7:
        monthStr = 'Aug'
        break;
      case 8:
        monthStr = 'Sep'
        break;
      case 9:
        monthStr = 'Oct'
        break;
      case 10:
        monthStr = 'Nov'
        break;
      case 11:
        monthStr = 'Dec'
        break;
    }
    return monthStr;
  }

}
